import { SettingItem } from '../../../services/soap/features/responses/GetFormSettingsResponse';
import { Divider, Flex } from '@adobe/react-spectrum';
import { CreateBillingItemsFields, CreateContextInfoFields, CreateCustomFormFieldForContextType, CreateCustomFormFields, CreatePersonFields, CreateProjectFields, CreateSalesItemsFields, CreateTechnologyItemsFields, CreateTrackingCodeFields } from './ContextFields';
import { FPATemplateItem } from '../../../infra/protected/FPA/FPATemplateItem';
import { FPAData } from '../../../infra/protected/FPA/FPAData';
import { ContextNewDialogMode } from './ContextNewDialog';

export interface IProjectContextFieldsProps {
    settings: SettingItem[];
    parentItem: FPAData | null;
    selectedItem?: FPATemplateItem;
    setFormData?: (key: string, value: any, isNew: boolean) => void;
    getFormData?: (key: string) => any;
    contextTypeFormId?: string;
    activityType?: number;
    projectType?: number;
    mode?: ContextNewDialogMode;
}

export function ProjectContextFields ({
    settings,
    parentItem,
    selectedItem,
    setFormData,
    getFormData,
    contextTypeFormId,
    activityType,
    projectType,
    mode

}: IProjectContextFieldsProps) {
  return (
    <Flex direction={'column'} gap={'size-100'}>

        <CreateProjectFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} setFormData={setFormData} mode={mode} getFormData={getFormData} />
        <CreateTrackingCodeFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} setFormData={setFormData} />
        <Divider size='M' />
        <CreateContextInfoFields settings={settings} 
                                parentItem={parentItem} 
                                selectedItem={selectedItem} 
                                showFolders={true} 
                                showProjects={false} 
                                showActivities={false} 
                                activityType={activityType} 
                                setFormData={setFormData}
                                projectType={projectType}
                                />
        <Divider size='M' />
        <CreateCustomFormFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} setFormData={setFormData} getFormData={getFormData} />
        <CreateCustomFormFieldForContextType formId={contextTypeFormId} setFormData={setFormData} getFormData={getFormData} />
        <CreatePersonFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} setFormData={setFormData} />
        <CreateSalesItemsFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} setFormData={setFormData} />
        <CreateBillingItemsFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} setFormData={setFormData} />
        <CreateTechnologyItemsFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} setFormData={setFormData} />
    </Flex>    
  );
}
